import { render } from "./LastOrdered.vue?vue&type=template&id=6a464f59&scoped=true"
import script from "./LastOrdered.vue?vue&type=script&lang=js"
export * from "./LastOrdered.vue?vue&type=script&lang=js"

import "./LastOrdered.vue?vue&type=style&index=0&id=6a464f59&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a464f59"]])

export default __exports__